import { ChevronDown, LogOut } from 'lucide-react';
import { useEffect, useRef, useState } from 'react';
import { signOut } from '../api/client.js';
import { useMe } from '../api/queries.js';

const initials = (text: string) =>
  text
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join('');

/** The picture Security holds for this person; their initials when there is none. */
function Avatar({ name, url }: { name: string; url: string | null }) {
  const [failed, setFailed] = useState(false);
  if (url && !failed) {
    return <img className="appbar-avatar" src={url} alt="" width={32} height={32} referrerPolicy="no-referrer" onError={() => setFailed(true)} />;
  }
  return <span className="appbar-avatar">{initials(name) || '•'}</span>;
}

/** App bar user menu: who is signed in, and the one action that ends the session. */
export function UserMenu() {
  const me = useMe();
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const name = me.data?.user.name ?? 'Utente';

  useEffect(() => {
    if (!open) return;
    const onPointer = (event: MouseEvent) => {
      if (!root.current?.contains(event.target as Node)) setOpen(false);
    };
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('mousedown', onPointer);
    document.addEventListener('keydown', onKey);
    return () => {
      document.removeEventListener('mousedown', onPointer);
      document.removeEventListener('keydown', onKey);
    };
  }, [open]);

  return (
    <div className="user-menu" ref={root}>
      <button type="button" className="user-trigger" aria-haspopup="menu" aria-expanded={open} onClick={() => setOpen((value) => !value)}>
        <Avatar name={name} url={me.data?.user.avatarUrl ?? null} />
        <span>{name}</span>
        <ChevronDown size={15} className={open ? 'open' : undefined} />
      </button>

      {open && (
        <div className="user-dropdown" role="menu">
          <button type="button" role="menuitem" autoFocus onClick={() => void signOut()}>
            <LogOut size={15} />
            Esci
          </button>
        </div>
      )}
    </div>
  );
}
